<template>
    <div
        class="convention-section-title"
        @mouseover="isHovering = true"
        @mouseleave="isHovering = false"
    >
        <typo :id="id" :name="`cc-${type}`">
            <span ref="element" v-html="title" />
            <action
                v-if="isHovering && type === 'h1' && shouldDisplayPrintIcon"
                name="link"
                class="print-section"
                with-icon="mdi-printer"
                :nochevron="true"
                colorIcon="white"
                @click="printSection()"
            />
        </typo>
    </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "src/bus/eventBus";
import scrollManager from "./managers/scrollManager";

export default Vue.extend({
    components: {},
    props: ["title", "type", "id", "pathIds", "cspFilters"],
    data() {
        return {
            isHovering: false,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.element = this.$refs.element;
            this.observer = scrollManager.observeTitle(this.element, () => {
                EventBus.$emit("convention-section-title:scrolled", this.pathIds);
            });
        });
    },
    methods: {
        printSection() {
            let routeData = this.$router.resolve({
                name: "convention-section-print",
                params: { sectionKey: this.id },
                query: { csp: this.cspFilters ? this.cspFilters.join(",") : null },
            });
            window.open(routeData.href, "_blank");
        },
    },
    destroyed() {
        this.observer.unobserve(this.element);
    },
    computed: {
        shouldDisplayPrintIcon() {
            return (
                this.$route.name === "convention-obligations" ||
                this.$route.name === "convention-obligations-slug"
            );
        },
    },
});
</script>

<style lang="sass">
=line
    display: block
    height: 1px
    background: $color-secondary
    content: ""
    flex-grow: 1

.convention-section-title

    .cc-h1
        text-transform: uppercase
        text-align: center
        background: $color-secondary
        color: white
        display: block
        margin-top: 50px
        margin-bottom: 20px
        padding: 5px 0
        position: relative
        .print-section
            position: absolute
            right: 0
            top: 50%
            transform: translateY(-50%)
    .cc-h2
        display: block
        position: relative
        margin: 50px 0 30px 0
        padding-bottom: 10px
        &:before
            position: absolute
            width: 50px
            bottom: 0
            content: ""
            height: 1px
            background: $color-secondary

    .cc-h3
        position: relative

    .cc-h4
        position: relative
        display: block
        margin-top: 16px
        margin-bottom: 16px

    .cc-h5
        position: relative
        margin-bottom: 8px
        margin-top: 8px

    .cc-note-di
        font-style: italic
        font-weight: normal

@media print
    .convention-section-title
        .cc-h1
            margin: 5mm 0 1mm 7.5mm !important
            background-color: transparent
            color: $color-secondary
            font-size: 20pt !important
            font-weight: 300 !important
            letter-spacing: 0.01em !important
            line-height: 1 !important
            text-align: left
            display: block
            break-inside: avoid

        .cc-h2
            margin: 5mm 0 1mm 7.5mm !important
            padding: 0.1mm 0 0
            border-top: 0.25mm solid currentColor
            border-bottom: 0.25mm solid currentColor
            font-size: 11pt !important
            font-weight: 600 !important
            letter-spacing: 0.02em !important
            line-height: 1.8 !important
            text-transform: uppercase
            display: block
            break-inside: avoid
            &:before
                display: none

        .cc-h3
            margin: 5mm 0 1mm 7.5mm !important
            display: block
            break-inside: avoid

        .cc-h4
            margin: 5mm 0 1mm 7.5mm !important
            font-size: 10pt !important
            letter-spacing: 0.04em !important
            text-transform: uppercase
            text-decoration: none !important
            display: block
            break-inside: avoid

        .cc-h5
            margin: 5mm 0 2mm 7.5mm !important
            font-size: 10pt !important
            font-weight: 600
            letter-spacing: 0.04em !important
            display: block
            break-inside: avoid
</style>
